import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { useTrackVisibility } from "react-intersection-observer-hook";

import {
	IconFillSafetySvg,
	IconFillOriginAirFreightSvg,
	IconFillFirstNameBasistSvg,
	IconFillPreciselyControlledSvg,
} from "@/assets/images";
const { useBreakpoint } = Grid;
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper";
import { useEffect, useState } from "react";

export function PrivateJetTravelBenefit({ we_operate_differently = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);

	const getHeightOfBanner = () => {
		let height = "100%";
		if (screens.xs) {
			height = "240px";
		}
		return height;
	};

	return (
		<HomeUtilitiesContainer ref={ref} gutter={[{ xxl: 40, xl: 34, lg: 30, md: 28, sm: 18, xs: 12 }, 20]}>
			{visible && (
				<>
					<EachCol className="image-column" xxl={12} xl={12} lg={12} md={24} xs={24}>
						<ImageContainer>
							<EachImage className="animate__animated animate__fadeInUp">
								<RAImage
									url={we_operate_differently?.photo || PATH_PUBLIC_IMAGES.private_jet_travel_4}
									width="100%"
									height={getHeightOfBanner()}
									// height="100%"
									borderRadius="12px"
									className="image-left"
								/>
							</EachImage>
						</ImageContainer>
					</EachCol>
					<EachCol className="introduction-column" xl={12} lg={12} md={24} xs={24}>
						<WrapperContent className="animate__animated animate__fadeInUp">
							<RATypography variant={screens?.xs ? "h4" : "h2"}>
								{we_operate_differently?.title || ""}
							</RATypography>
						</WrapperContent>
						<div className="animate__animated animate__fadeInUp">
							<RATypography variant="body3" top="8px" color="#595959">
								{we_operate_differently?.sub_title || ""}
							</RATypography>
						</div>
						<WrapperSection gutter={[20, 20]}>
							<Col
								xxl={12}
								xl={12}
								lg={12}
								md={24}
								sm={24}
								xs={24}
								className="animate__animated animate__fadeInUp"
							>
								<CardSectionItem
									icon={<RAImage url={IconFillSafetySvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light1?.title || ""}
									description={we_operate_differently?.hight_light1?.description || ""}
								/>
							</Col>
							<Col
								xxl={12}
								xl={12}
								lg={12}
								md={24}
								sm={24}
								xs={24}
								className="animate__animated animate__fadeInUp"
								style={{ animationDuration: "0.5s" }}
							>
								<CardSectionItem
									icon={<RAImage url={IconFillOriginAirFreightSvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light2?.title || ""}
									description={we_operate_differently?.hight_light2?.description || ""}
								/>
							</Col>
							<Col
								xxl={12}
								xl={12}
								lg={12}
								md={24}
								sm={24}
								xs={24}
								className="animate__animated animate__fadeInUp"
								style={{ animationDuration: "1s" }}
							>
								<CardSectionItem
									icon={<RAImage url={IconFillPreciselyControlledSvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light3?.title || ""}
									description={we_operate_differently?.hight_light3?.description || ""}
								/>
							</Col>
							<Col
								xxl={12}
								xl={12}
								lg={12}
								md={24}
								sm={24}
								xs={24}
								className="animate__animated animate__fadeInUp"
								style={{ animationDuration: "1.5s" }}
							>
								<CardSectionItem
									icon={<RAImage url={IconFillFirstNameBasistSvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light4?.title || ""}
									description={we_operate_differently?.hight_light4?.description || ""}
								/>
							</Col>
						</WrapperSection>
					</EachCol>
				</>
			)}
		</HomeUtilitiesContainer>
	);
}

export function PrivateJetTravelBenefitTablet({ we_operate_differently = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);
	const getHeightOfBanner = () => {
		let height = "100%";
		if (screens.xs) {
			height = "240px";
		}
		return height;
	};

	return (
		<HomeUtilitiesContainer
			ref={ref}
			// gutter={[{ xxl: 68, xl: 68, lg: 40, md: 32, sm: 0, xs: 0 }, 12]}
			style={{ padding: "0 84px" }}
		>
			{visible && (
				<>
					<EachCol className="image-column" xxl={12} xl={12} lg={12} md={24} xs={24}>
						<ImageContainer>
							<EachImage className="animate__animated animate__fadeInUp">
								<RAImage
									url={we_operate_differently?.photo || PATH_PUBLIC_IMAGES.private_jet_travel_4}
									width="100%"
									height={getHeightOfBanner()}
									// height="100%"
									borderRadius="12px"
									className="image-left"
								/>
							</EachImage>
						</ImageContainer>
					</EachCol>
					<EachCol className="introduction-column" xl={12} lg={12} md={24} xs={24}>
						<WrapperContent className="animate__animated animate__fadeInUp">
							<RATypography variant={screens?.xs ? "h4" : "h2"}>
								{we_operate_differently?.title || ""}
							</RATypography>
						</WrapperContent>
						<div className="animate__animated animate__fadeInUp">
							<RATypography variant="body3" top="8px" color="#595959">
								{we_operate_differently?.sub_title || ""}
							</RATypography>
						</div>
						<Swiper
							pagination={{
								clickable: true,
							}}
							autoplay={{
								delay: 2500,
								disableOnInteraction: false,
							}}
							modules={[Pagination, Autoplay]}
							spaceBetween={20}
							loop={true}
							style={{ marginTop: 20 }}
						>
							<SwiperSlide>
								<CardSectionItem
									icon={<RAImage url={IconFillSafetySvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light1?.title || ""}
									description={we_operate_differently?.hight_light1?.description || ""}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<CardSectionItem
									icon={<RAImage url={IconFillOriginAirFreightSvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light2?.title || ""}
									description={we_operate_differently?.hight_light2?.description || ""}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<CardSectionItem
									icon={<RAImage url={IconFillPreciselyControlledSvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light3?.title || ""}
									description={we_operate_differently?.hight_light3?.description || ""}
								/>
							</SwiperSlide>
							<SwiperSlide>
								<CardSectionItem
									icon={<RAImage url={IconFillFirstNameBasistSvg} width={24} height={24} />}
									title={we_operate_differently?.hight_light4?.title || ""}
									description={we_operate_differently?.hight_light4?.description || ""}
								/>
							</SwiperSlide>
						</Swiper>
					</EachCol>
				</>
			)}
		</HomeUtilitiesContainer>
	);
}

const CardSectionItem = ({ icon, title = "", description = "", divider = false }) => {
	return (
		<WrapperItem divider={divider}>
			{icon}
			<RATypography variant="sub-heading4" color="#222222">
				{title}
			</RATypography>
			<RATypography variant="body3" color="#595959">
				{description}
			</RATypography>
		</WrapperItem>
	);
};

const ImageContainer = styled.div`
	width: 100%;
	height: 100%;
	min-height: 240px;
`;
const EachImage = styled.div`
	height: 100%;
	width: 100%;
`;
const HomeUtilitiesContainer = styled(Row)`
	width: 100%;
	.swiper-pagination-horizontal {
		position: unset;
		margin-top: 16px;
	}
	.swiper-pagination-bullet-active {
		background: #ffb11a;
	}
`;
const EachCol = styled(Col)`
	padding: 20px 0px 0 0px;
	@media (max-width: 1200px) {
		padding: 20px 24px 0 24px;
	}
`;
const WrapperContent = styled.div`
	padding: 4px 12px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
const WrapperSection = styled(Row)`
	padding: 16px 0 0 0;
`;
const WrapperItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 16px;
	gap: 12px;
	width: 100%;
	height: 100%;
	min-height: 240px;
	background: #ffffff;
	border-radius: 8px;
	border: 1px solid #e9e8e8;
`;
